import { render, staticRenderFns } from "./mandataireEtpartenaire.vue?vue&type=template&id=506b138e&scoped=true"
import script from "./mandataireEtpartenaire.vue?vue&type=script&lang=js"
export * from "./mandataireEtpartenaire.vue?vue&type=script&lang=js"
import style0 from "./mandataireEtpartenaire.vue?vue&type=style&index=0&id=506b138e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506b138e",
  null
  
)

export default component.exports